// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ground-loop-swing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ground-loop-swing/ground-loop-swing.js';

mount([g0]);
